<template>
  <table width="100%">
    <tr>
      <td>
        <label
          :class="[required ? 'required labelText' : 'labelText' ]"
        >
          {{ label }}
        </label>
      </td>
    </tr>
    <tr>
      <td>
        <Multiselect 
          v-model="value"
          :tag-placeholder="placeholderToTag" 
          :placeholder="placeholder" 
          :label="name" 
          track-by="code" 
          :options="optionsToSelect" 
          :multiple="multipleSelection" 
          :taggable="true" 
          :searchable="true"
          :close-on-select="closeOnSelect"
          class="shadow-sm"
          @tag="handleAddTag"
        />
      </td>
    </tr>
  </table>
</template>
<script>
import Multiselect from 'vue-multiselect'

export default {
  data() {
    return {
      value: [],
    }
  },
  watch: {
    initialValue(val) {
      this.value = val
    }
  },
  components: {
    Multiselect
  },
  props: {
    initialValue: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ''
    },
    optionsToSelect: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String, 
      default: ''
    },
    placeholderToTag: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    multipleSelection: {
      type: Boolean,
      default: true
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleAddTag() {
      this.$emit('handleAddTagging', this.value)
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>
.multiselect__tags {
  color: grey;
  box-shadow: inset 0 0 0 1px grey !important;
  background-color: white;
  min-height: 40px !important;
}

.multiselect__tags.padd-r {
  padding-left: 20%;
}

.multiselect:hover {
  box-shadow: 0 0 0 2px blue, inset 0 0 0 1px grey !important;
  background-color: white;
}

.multiselect__element {
  background: #3b82ee;
  color: white;
  padding: 0;
  margin: 0;
}

.multiselect__option,
.multiselect__option--selected,
.multiselect__option--highlight {
  background: #3b82ee;
  color: white;
  opacity: .9;
}
.multiselect__option::hover {
  background: #3b82ee;
}

.multiselect__option--selected.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight::after {
  background: #1e71ee;

}

.multiselect__option::after, 
.multiselect__option--highlight {
  background: #3b82ee;
}

.multiselect__tag {
    background: #3b82ee
}
.multiselect__tag-icon::after {
  color: #fff;
}

.required::after {
  color: #6040b9;
  content: ' *';
  font-size: 16px;
}

.wrapper {
  width: 100%;
}

.labelText {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: grey;
  float: left;
  border-radius: 4px;
}
</style>